
export const SHOW_FILE = 'SHOW_FILE'
export const UNSET_EXPLORER = 'UNSET_EXPLORER'
export const SET_FORTUNE = 'SET_FORTUNE'
export const EXPLORER_TOGGLE = 'EXPLORER_TOGGLE'
export const CHANGE_EXPLORER_PATH = 'CHANGE_EXPLORER_PATH'
